@use "@material/theme"with ($primary: rgba(255, 255, 255, 0.8),
);
@use "@material/circular-progress/mdc-circular-progress";

:host {
  display: block;
}

.mdc-circular-progress {
  width: 24px;
  height: 24px;
}